import React from 'react';

import './ExperienceCard.css';

const ExperienceCard = ({ content }) => {
  const { title, text, photo } = content;
  return <div className="experience-card">
    <img className="experience-card-photo" src={photo} alt={title || "Person"} />

    <div className="experience-card-info">
      <h4>{title}</h4>
      <p className="body_dt">
        {text}
      </p>
    </div>
  </div>;
};

export default ExperienceCard;
